import styled from 'astroturf/react';

const GuestScreenContianer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--white);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 30px 60px;
  border-radius: 15px;
  box-shadow: 0 2px 4px 0 rgba(39, 39, 39, 0.15);
  width: 520px;

  h2 {
    margin-bottom: 20px;
  }
  div[class*='loading'] {
    margin-bottom: 20px;
    span {
        text-align: center;
    } 
    p {
      margin: 0px;
    }
  }  

  div[class*='login__logo'] {
    margin-bottom: 20px;
  }
`;


export default {
  GuestScreenContianer,
};